module.exports = __webpack_public_path__ + "media/images/chat_bg_dark_new-48a3c1b6f761e788a987ce4070e9e505.jpeg";